import { useReveal, SpringParallax, Image, VideoLoop } from '@ccg/core';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledStage from './Stage.style.js';

const Stage = (_ref) => {
  let {
    headline,
    subline,
    image,
    video,
    loop,
    breadcrumbLink
  } = _ref,
      props = _objectWithoutProperties(_ref, ["headline", "subline", "image", "video", "loop", "breadcrumbLink"]);

  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledStage, _extends({
    ref: ref,
    hasMedia: Boolean(image || video)
  }, props), /*#__PURE__*/React$1.createElement(Grid$1, null, image || video ? /*#__PURE__*/React$1.createElement("div", {
    className: "stage__image"
  }, /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, image && !video ? /*#__PURE__*/React$1.createElement(Image, {
    src: image.url || image.src,
    ratio: `${image.width}:${image.height}`,
    srcset: image.srcset,
    alt: image.alt,
    sizes: "(min-width: 768px) 50vw, 75vw",
    lazy: true
  }) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: loop
  }) : null))) : null, /*#__PURE__*/React$1.createElement("div", {
    className: "stage__headline"
  }, /*#__PURE__*/React$1.createElement(SpringParallax, null, breadcrumbLink && /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "stage__breadcrumbLink"
  }, breadcrumbLink, {
    icon: "arrowLeft",
    transform: "uppercase"
  }), breadcrumbLink.label), /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "h1",
    variant: "headline",
    reveal: true,
    isVisible: isVisible
  }, headline))), subline && /*#__PURE__*/React$1.createElement("div", {
    className: "stage__subline"
  }, /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "subline",
    as: "h2",
    hasAccent: true,
    reveal: true,
    isVisible: isVisible
  }, subline)))));
};

Stage.propTypes = {
  loop: PropTypes$1.bool,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number
  }),
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  breadcrumbLink: PropTypes$1.shape()
};
Stage.defaultProps = {
  loop: true,
  image: null,
  video: null,
  subline: null,
  breadcrumbLink: null
};

export default Stage;
